<template>
  <div>
    <div class="container"
         v-if="certificateList.length>0">
      <!--<i-videolist :video_newest="video_hottest"></i-videolist>-->
      <ul>
        <li v-for="item in certificateList"
            @click="pdfshow(item.creImgUrl)">
          <img :src="item.creImgUrl"
               alt="">
          <div>
            <p>视频名称: <span>{{item.video.vTitle}}</span></p>
            <p>视频时长: <span>{{formatDuring(item.video.vTime)}}</span></p>
          </div>
        </li>
      </ul>
    </div>
    <div class="none"
         v-if="certificateList.length<1">
      <img src="../../assets/images/none.png"
           alt="">
      <p>暂无证书</p>
    </div>
    <div v-if='showimg'
         class="showimg"
         @click="showimg=false">
      <img :src="imgurl"
           alt="">
    </div>

  </div>
</template>
<script>
import AppSetting from '../../AppSetting';
import loginService from '../../plugin/extendFn/loginService';
import iVideolist from '../container/videoList'
export default {
  data () {
    return {
      video_hottest: null,
      wxuser: null,
      certificateList: [],
      imgurl: '',
      showimg: false,
    }
  },
  props: {},
  methods: {
    pdfshow (url) {
      this.showimg = true;
      this.imgurl = url

    },
    formatDuring (mss) {
      let days = parseInt(mss / (1000 * 60 * 60 * 24));
      let hours = parseInt((mss % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      let minutes = parseInt((mss % (1000 * 60 * 60)) / (1000 * 60));
      let seconds = parseInt((mss % (1000 * 60)) / 1000);
      if (days != 0) {
        return days + '天' + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
      }
      if (hours != 0) {
        return hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
      }
      if (minutes != 0) {
        return minutes + " 分钟 " + seconds + " 秒 ";
      }
      if (seconds != 0) {
        return seconds + " 秒 ";
      }

    }
  },
  components: {
    iVideolist
  },
  computed: {},
  async mounted () {
    this. wxuser= await loginService.getLoginUser();
    document.title = '我的证书';
    // this.$postHttp(AppSetting.baseUrl + '/student/complete/video',{uid:this.wxuser.uId,}).then((res)=>{
    //   if(res.data.code==0){
    //     this.video_hottest = res.data.list;
    //   }
    // })
    this.$postHttp(AppSetting.baseUrl + '/student/credential/list', { uid: this.wxuser.uId, }).then((res) => {
      if (res.data.code == 0) {
        this.certificateList = res.data.list;
      }
    })
  }
}
</script>
<style scoped lang="scss">
.none {
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
  padding-top: 2.64rem;
  box-sizing: border-box;
  img {
    width: 100%;
  }
  p {
    font-size: 0.38rem;
    color: #666666;
    text-align: center;
  }
  /*min-height: 100vh;*/
}
.container {
  font-size: 0.16rem;
  padding: 0.2rem 0.3rem;
  box-sizing: border-box;
  margin-bottom: 1.18rem;
  ul {
    li {
      border: 1px solid #e6e6e6;
      display: flex;
      padding: 0.2rem 0.2rem;
      box-sizing: border-box;
      margin-bottom: 0.2rem;
      > div {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      img {
        width: 2.2rem;
        height: 1.6rem;
        margin-right: 0.2rem;
        flex-shrink: 0;
      }
    }
  }
}
.showimg {
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  img {
    width: 100%;
    margin-top: 2rem;
    z-index: 1001;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/me/end.vue